import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/heave/heave.js';
      import {LinearAdvice} from '@oicl/openbridge-webcomponents/dist/building-blocks/instrument-linear/advice.js';
import {VesselImage} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/watch.js';
import {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';

      export interface Props {
     heave?: number;
     gainScale?: number;
     minTrendHeave?: number;
     maxTrendHeave?: number;
     draftOffset?: number;
     advice?: LinearAdvice[];
     instrumentRange?: number;
     vesselImage?: VesselImage;
     priority?: Priority
   }

      
  
      export type {LinearAdvice} from '@oicl/openbridge-webcomponents/dist/building-blocks/instrument-linear/advice.js';
export type {VesselImage} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/watch.js';
export type {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcHeave',
  props: {
    heave: {},
    gainScale: {},
    minTrendHeave: {},
    maxTrendHeave: {},
    draftOffset: {},
    advice: {},
    instrumentRange: {},
    vesselImage: {},
    priority: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-heave',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})